import React from 'react';
import { useStyles } from '@team-griffin/stylr';

const useStylesheet = () =>
  useStyles({
    default: {
      root: {
        maxWidth: '100%',
        maxHeight: '100%',
        display: 'block',
      },
    },
  });

// I'm not worried about the repetition of the prefix here as it'll be normalised away by gzip compression
// as a dictionary item.
const starMap = {
  1: 'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/4627f20d-7040-4e7f-9abe-36501b4dd2e8/1-256x48.png',
  1.5: 'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/8f0e6ed7-723f-41e5-a402-2fd90025d763/1_5-256x48.png',
  2: 'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/a68be276-2c5e-4257-92ed-bc37a6a48950/2-256x48.png',
  2.5: 'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/a4e13b3a-499a-46e3-91f2-cc8c4b95e218/2_5-256x48.png',
  3: 'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/2f119448-0f7a-4bb5-878a-2a589e768761/3-256x48.png',
  3.5: 'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/0b1ee116-1add-4097-a3ad-dbbdcb4b9e41/3_5-256x48.png',
  4: 'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/22fcec44-6e44-49db-af28-940f92b03cb0/4-256x48.png',
  4.5: 'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/bbb6dfba-fd77-4f0c-b922-ab3cdc8a39af/4_5-256x48.png',
  5: 'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/91a13237-f0a8-49a3-bbf1-d6edf5fc1b69/5-256x48.png',
} as {
  [key: string]: string;
};

export const TrustpilotStars = ({ rating }: { rating: string }) => {
  const { styles } = useStylesheet();
  return <img loading="lazy" src={starMap[rating]} alt={`Trustpilot ${rating}/5`} style={styles.root} />;
};

TrustpilotStars.displayName = 'TrustpilotStars';

export default TrustpilotStars;
